import { BookingState } from "../../types";
import {
  CREATE_BOOKING_SUCCESS,
  DELETE_BOOKING_SUCCESS,
  EDIT_BOOKING_SUCCESS,
  FETCH_ALL_BOOKINGS_SUCCESS,
  SET_BOOKING_DATE,
  SET_BOOKING_USERID,
  CLEAR_BOOKING_DATA,
  PREPARE_BOOKING_BRANCH,
  PREPARE_BOOKING_COURTS,
  GET_USER_BOOKING_HISTORY,
  SET_SHARE_BOOKING,
  SET_SHARE_BOOKING_DATA,
  LOGOUT_USER_REQUEST
} from "../constants";

const initialState: BookingState = {
  bookings: [],
  preBranch: null,
  preCourts: [],
  preBookingDate: "",
  preBookingUserId: "",
  isShareBooking: false,
  shareBookingTime: "",
  shareBookingDuration: "",
  shareBookingCourt: "",
  shareAdditionalInfo: "",
};

// eslint-disable-next-line
export default (state = initialState, action: any): any => {
  switch (action.type) {
    case CREATE_BOOKING_SUCCESS:
      return {
        ...state,
        bookings: [...state.bookings, action.payload.newBooking],
      };
    case FETCH_ALL_BOOKINGS_SUCCESS:
      return {
        ...state,
        bookings: action.payload.allBookings,
      };
    case EDIT_BOOKING_SUCCESS:
      return {
        ...state,
        bookings: action.payload.allBookings,
      };
    case DELETE_BOOKING_SUCCESS:
      return {
        ...state,
        bookings: action.payload.allBookings,
      };
    case SET_BOOKING_DATE:
      return {
        ...state,
        preBookingDate: action.payload.date,
      };
    case SET_BOOKING_USERID:
      return {
        ...state,
        preBookingUserId: action.payload.userId,
      };
    case CLEAR_BOOKING_DATA:
      return {
        ...state,
        preBookingDate: "",
        preBranch: null,
        preCourts: [],
        preBookingUserId: "",
        isShareBooking: false,
        shareBookingTime: "",
        shareBookingDuration: "",
        shareBookingCourt: "",
        shareAdditionalInfo: ""
      };
    case PREPARE_BOOKING_BRANCH:
      return {
        ...state,
        preBranch: action.payload.branch,
      };
    case PREPARE_BOOKING_COURTS:
      return {
        ...state,
        preCourts: action.payload.courts,
      };
    case GET_USER_BOOKING_HISTORY:
      return {
        ...state,
        bookings: action.payload.bookings,
      };
    case SET_SHARE_BOOKING:
      return {
        ...state,
        isShareBooking: true,
      };
    case SET_SHARE_BOOKING_DATA:
      return {
        ...state,
        shareBookingTime: action.payload.bookingTime,
        shareBookingDuration: action.payload.bookingDuration,
        shareBookingCourt: action.payload.bookingCourt,
        shareAdditionalInfo: action.payload.additionalInfo
      };
    case LOGOUT_USER_REQUEST:
      return initialState;
    default:
      return state;
  }
};
